import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";

const reviews = [
  {
    name: "Sarah M.",
    location: "Manchester",
    rating: 5,
    text: "Booked Dubai for the whole family last minute and it was completely seamless. Kids loved every second, husband stopped moaning for once 😂 will 100% be back next year.",
    trip: "Manchester → Dubai",
    avatar: "SM",
    color: "#fe6e00",
  },
  {
    name: "Tariq H.",
    location: "Birmingham",
    rating: 5,
    text: "Honestly I was sceptical at first — never heard of SKYSALE PK before and the price was Rs 200 cheaper than everywhere else. Thought something was off. But nope, everything was perfect.",
    trip: "Birmingham → Karachi",
    avatar: "TH",
    color: "#7c3aed",
  },
  {
    name: "Jake R.",
    location: "London",
    rating: 4,
    text: "Did the job. Good price, easy checkout, got my e-ticket straight away. Site's clean and doesn't bombard you with upsells every 5 seconds like the big ones do. That alone is refreshing.",
    trip: "London → New York",
    avatar: "JR",
    color: "#7c3aed",
  },
  {
    name: "Fatima A.",
    location: "Leicester",
    rating: 5,
    text: "Me and my husband flew to Istanbul for our anniversary. Found SKYSALE PK at like 11pm the night before and still managed to get everything sorted. The support team picked up immediately. Brilliant.",
    trip: "Leicester → Istanbul",
    avatar: "FA",
    color: "#059669",
  },
  {
    name: "Callum T.",
    location: "Glasgow",
    rating: 5,
    text: "Solo trip to New York sorted in about 10 minutes. Even got seat selection which I wasn't expecting. Landed fine, had a great time, came back broke but happy. 10/10 would recommend.",
    trip: "Glasgow → JFK",
    avatar: "CT",
    color: "#ec4899",
  },
  {
    name: "Priya N.",
    location: "Coventry",
    rating: 5,
    text: "Had a small issue with my middle name being wrong on the ticket — I panicked. Called support and it was fixed within 20 minutes. That kind of response is genuinely rare. Really impressed.",
    trip: "Coventry → Toronto",
    avatar: "PN",
    color: "#0891b2",
  },
  {
    name: "Bilal K.",
    location: "Bradford",
    rating: 5,
    text: "Third time booking through SKYSALE PK now. Used to spend ages comparing on all the different sites but the prices here are consistently good so I just stopped bothering with the rest.",
    trip: "Bradford → Lahore",
    avatar: "BK",
    color: "#f59e0b",
  },
  {
    name: "Helen W.",
    location: "Bristol",
    rating: 4,
    text: "I travel for work about twice a month. This has genuinely become my go-to. Clean, quick, and the confirmation emails actually have all the info I need without having to dig through PDFs.",
    trip: "Bristol → Frankfurt",
    avatar: "HW",
    color: "#4f46e5",
  },
  {
    name: "Margaret O.",
    location: "Leeds",
    rating: 5,
    text: "My daughter set this up for me as I'm not great with technology if I'm honest. But even I found it quite simple. Flight was on time, seats were fine. Very impressed for my first time booking online.",
    trip: "Leeds → Dubai",
    avatar: "MO",
    color: "#0d9488",
  },
  {
    name: "Imran S.",
    location: "Luton",
    rating: 5,
    text: "Flew Luton to Karachi return for under Rs 480. You show me anywhere else offering that right now and I'll eat my hat 😂 Booked it in literally 3 minutes. Site's fast, works on my phone, job done.",
    trip: "Luton → Karachi",
    avatar: "IS",
    color: "#f43f5e",
  },
  {
    name: "Naomi C.",
    location: "Nottingham",
    rating: 4,
    text: "Website is decent, nothing flashy but it works. Flight was on time, price was fair, no hidden fees that appeared at checkout. That last bit is the main thing for me. Pleasantly surprised.",
    trip: "Nottingham → Jeddah",
    avatar: "NC",
    color: "#a855f7",
  },
  {
    name: "Yusuf A.",
    location: "East London",
    rating: 5,
    text: "We hadn't been able to afford a proper family holiday in nearly 3 years. Found an amazing deal to Turkey on here and the kids were absolutely over the moon. Genuinely can't thank you enough.",
    trip: "London → Antalya",
    avatar: "YA",
    color: "#16a34a",
  },
];

// Split into two rows for opposite-direction scrolling
const row1 = reviews.slice(0, 6);
const row2 = reviews.slice(6, 12);
const ticker1 = [...row1, ...row1];
const ticker2 = [...row2, ...row2];

function StarRating({ rating }) {
  return (
    <div className="testimonials-stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          className={`testimonials-star ${i < rating ? "testimonials-star-on" : "testimonials-star-off"}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

function ReviewCard({ review }) {
  return (
    <div className="testimonials-card">
      <div className="testimonials-card-top">
        <div>
          <p className="testimonials-name">{review.name}</p>
          <p className="testimonials-location">{review.location}</p>
        </div>
        <StarRating rating={review.rating} />
      </div>

      <p className="testimonials-text">"{review.text}"</p>

      <div className="testimonials-trip">
        <svg className="testimonials-trip-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 3l14 9-14 9V3z" />
        </svg>
        <span className="testimonials-trip-label">{review.trip}</span>
      </div>
    </div>
  );
}

function AnimatedStat({ target, label, display }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1800;
          const steps = 60;
          const increment = target / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(current);
            }
          }, duration / steps);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div ref={ref} className="testimonials-stat testimonials-stat-animated">
      <span className="testimonials-stat-value">{display(count)}</span>
      <span className="testimonials-stat-label">{label}</span>
    </div>
  );
}

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2 className="testimonials-title">What Our Customers Say</h2>
        <p className="testimonials-subtitle">
          Over 500,000 passengers have booked through SKYSALE PK. Here's what some of them had to say.
        </p>
      </div>

      {/* Mobile: snap-scroll carousel (single row, near-full-width cards) */}
      <div className="testimonials-mobile">
        <div className="testimonials-mobile-track">
          {reviews.map((review) => (
            <div key={review.name} className="testimonials-mobile-card">
              <div className="testimonials-card-top">
                <div className="testimonials-card-person">
                  <div className="testimonials-avatar" style={{ backgroundColor: review.color }}>
                    {review.avatar}
                  </div>
                  <div>
                    <p className="testimonials-name">{review.name}</p>
                    <p className="testimonials-location">{review.location}</p>
                  </div>
                </div>
                <StarRating rating={review.rating} />
              </div>
              <p className="testimonials-text">"{review.text}"</p>
              <div className="testimonials-trip">
                <svg className="testimonials-trip-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 3l14 9-14 9V3z" />
                </svg>
                <span className="testimonials-trip-label">{review.trip}</span>
              </div>
            </div>
          ))}
        </div>
        <p className="testimonials-mobile-hint">← Swipe to read more →</p>
      </div>

      {/* Desktop: dual-row auto-scroll ticker */}
      <div className="testimonials-desktop">
        <div className="testimonials-row" style={{ marginBottom: "1rem" }}>
          <div className="testimonials-fade-left" />
          <div className="testimonials-fade-right" />
          <div className="testimonials-ticker-ltr">
            {ticker1.map((review, i) => (
              <ReviewCard key={`r1-${i}`} review={review} />
            ))}
          </div>
        </div>

        <div className="testimonials-row">
          <div className="testimonials-fade-left" />
          <div className="testimonials-fade-right" />
          <div className="testimonials-ticker-rtl">
            {ticker2.map((review, i) => (
              <ReviewCard key={`r2-${i}`} review={review} />
            ))}
          </div>
        </div>
      </div>

      {/* Bottom trust strip */}
      <div className="testimonials-stats-wrap">
        <div className="testimonials-stats">
          <AnimatedStat
            target={500000}
            label="Happy Passengers"
            display={(n) => `${Math.round(n / 1000)}K+`}
          />
          {[
            { value: "4.9★", label: "Average Rating" },
            { value: "50+", label: "Airlines Available" },
            { value: "24/7", label: "Customer Support" },
          ].map((stat) => (
            <div key={stat.label} className="testimonials-stat">
              <span className="testimonials-stat-value">{stat.value}</span>
              <span className="testimonials-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
